import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

Vue.use(VueRouter);

//TODO implement middlewares as in spa example

const router = new VueRouter({
    routes: [
        { path: '/', component: require('./views/Home.vue'), name: 'home'},

        /**
         * Auth routes
         */
        { path: '/login', name: 'auth.login', component: require('./views/Login') },
        { path: '/register', name: 'auth.register', component: require('./views/auth/Register'), props: true },
        { path: '/verify/resend', name: 'auth.verify.resend', component: require('./views/auth/verification/Resend') },
        { path: '/verify/:token', name: 'auth.verify', props: true, component: require('./views/auth/verification/Verify') },
        { path: '/password/reset/:token', name: 'auth.password.reset', component: require('./views/auth/password/Reset'), props: true },
        { path: '/oauth/callback/:provider', name: 'auth.oauth.callback', component: require('./views/auth/oauth/Callback'), props: true },

        {
            path: '/kategorija/:categoryNodeId',
            component: require('./views/SubCategories'),
            props: true,
            name: 'category',
            meta: { auth: true }
        },
        {
            path: '/kategorija/:categoryNodeId/materiali',
            props: true,
            component: require('./views/CategoryMaterials'),
            name: 'category-materials',
            meta: { auth: true }
        },
        {
            path: '/upload',
            component: require('./views/Upload'),
            name: 'upload',
            props: true,
            meta: { auth: true }
        },
        {
            path: '/profils',
            component: require('./views/MyProfile'),
            name: 'profile',
            meta: { auth: true },
        },
        {
            path: '/profils/gramatzimes',
            component: require('./views/profile/MyBookmarks'),
            name: 'profile.bookmarks',
            meta: { auth: true },
        },
        {
            path: '/profils/kategorijas/:categoryNodeId',
            component: require('./views/profile/MySubCategories'),
            props: true,
            name: 'profile.categories',
            meta: { auth: true }
        },
        {
            path: '/profile/edit',
            name: 'profile.edit',
            component: require('./views/MyProfileEdit'),
            meta: { auth: true },
        },
        {
            path: '/profiles/:id',
            name: 'profiles',
            props: true,
            component: require('./views/Profile'),
            meta: { auth: true },
            children: [
                {
                    path: 'categories/:categoryNodeId',
                    props: true,
                    name: 'profiles.categories',
                    component: require('./views/Profile'),
                    meta: { auth: true }
                }
            ]
        },
        {
            path: '/inbox',
            component: require('./views/Inbox'),
            name: 'inbox',
            meta: { auth: true },
            children: [
                {
                    // UserProfile will be rendered inside User's <router-view>
                    // when /user/:id/profile is matched
                    path: 'comments',
                    name: 'inbox.comments',
                    component: require('./views/inbox/InboxComments'),
                    meta: { auth: true }
                },
                {
                    // UserPosts will be rendered inside User's <router-view>
                    // when /user/:id/posts is matched
                    path: 'messages',
                    name: 'inbox.messages',
                    component: require('./views/inbox/InboxMessages'),
                    meta: { auth: true }
                }
            ]
        },
        {
            path: '/material/:id',
            component: require('./views/Material.vue'),
            props: true,
            name: 'material',
            meta: { auth: true },
        },
        {
            path: '/material/:id/edit',
            component: require('./views/MaterialEdit.vue'),
            props: true,
            name: 'material-edit',
            meta: { auth: true },
        },

        {
            path: '/lapas-karte',
            component: require('./views/pages/SiteMap'),
            name: 'site-map',
            meta: { auth: false }
        },
        {
            path: '/sazinies',
            component: require('./views/pages/Contact'),
            name: 'contact',
            meta: { auth: false }
        },
        {
            path: '/jaunumi',
            component: require('./views/Posts'),
            name: 'posts',
            meta: { auth: false }
        },
        {
            path: '/jaunumi/:id',
            component: require('./views/Post'),
            name: 'post',
            props: true,
            meta: { auth: false }
        },
        {
            path: '/lapa/:slug',
            component: require('./views/pages/Page'),
            name: 'page',
            meta: { auth: false },
            props: true,
        },

        {
            path: '*',
            component: require('./views/Home.vue')
        }
    ]
});

// Before the Vue is mounted we can not launch modal. Therefore we redirect to login page.
// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.auth)
//         && store.getters.isAuthenticated === false) {
//
//         router.push({ name: 'auth.login' });
//     } else {
//         next();
//     }
// });

export default router



// WEBPACK FOOTER //
// ./resources/assets/js/router.js